import React from 'react';
import { View, StyleSheet } from 'react-native';

// On web, render PDFs natively using the browser's built-in PDF viewer via iframe
export default function Pdf({ source, style, onLoadComplete, onError }) {
  const uri = source?.uri || source?.url || (typeof source === 'string' ? source : '');

  React.useEffect(() => {
    if (uri && onLoadComplete) onLoadComplete(1, uri);
  }, [uri]);

  if (!uri) return null;

  return (
    <View style={[styles.container, style]}>
      <iframe
        src={uri}
        style={styles.iframe}
        title="PDF Document"
        onLoad={() => onLoadComplete && onLoadComplete(1, uri)}
        onError={() => onError && onError(new Error('Failed to load PDF'))}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  iframe: { width: '100%', height: '100%', border: 'none', flex: 1 },
});
